import { Component } from '@angular/core';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';

@Component({
  selector: 'app-gender-table',
  templateUrl: './gender-table.component.html',
  styleUrls: ['./gender-table.component.sass']
})
export class GenderTableComponent extends BaseListDirective {

  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('name_', 'FORM.TITLE', 1000, { frozen: true }),
  ];
  override title = 'MENU.GENDERS';
  override filterableFields = ['name_']
  override keys = {
    primary_key: 'gender_id',
    label: 'name_'
  }
  override filename = 'MENU.GENDERS';

  override getList(): void {
    this.query(this.data.core.genders()).subscribe()
  }

  override handleRows(data: any): void {
    super.handleRows(data);
    console.log(data);
  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.genderDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }
}
